import React from 'react';
import OrganicTrafficSplineChart from '../OrganicTrafficSplineChart';
import KeywordsWithOrganicTrafficSplineChart from '../KeywordsWithOrganicTrafficSplineChart';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { PercentTotalTrafficSplineChart } from '../../Total/PercentTotalTrafficSplineChart';
import { TrafficByTopicBarChart } from '../../TrafficByTopicBarChart';
import { TrafficAdvancedSearchBarChart } from '../../TrafficAdvancedSearchBarChart';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';
import { TrafficNoDataPlaceholder } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/Total/pages/NonTopicOrTopicGroupPage';
import { useTrafficAvailability } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/Total/hooks/useTrafficAvailability';
import OrganicTrafficGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/Organic/OrganicTrafficGrid';
import { ExportConfigProvider } from 'src/components/BeaconV2Components/common/AppExportModal/ExportModalContext';
import { ChartContextProvider } from 'src/utils/chartContext/ChartContextGroupContext';
import { CHART_CONTEXT_GROUPS, CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

/**
 * Organic traffic page for non topic views
 */
export function NonTopicOrTopicGroupPage() {
  const mainEntityType = useMainEntityType();
  const { dataAvailable } = useTrafficAvailability();

  return (
    <ExportConfigProvider overrideShouldIntercept={true}>
      <BasePageContainer>
        {dataAvailable ? (
          <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
            <ChartContextProvider
              group={CHART_CONTEXT_GROUPS.BEACON_ORGANIC_TRAFFIC_SPLINE.name}
              chartName={CHART_NAMES.BEACON_ORGANIC_TRAFFIC_SPLINE_CHART}
            >
              <OrganicTrafficSplineChart />
            </ChartContextProvider>
            <ChartContextProvider
              group={CHART_CONTEXT_GROUPS.BEACON_ORGANIC_TRAFFIC_BY_TOPIC.name}
              chartName={CHART_NAMES.BEACON_ORGANIC_TRAFFIC_BY_TOPIC_BAR}
            >
              <TrafficByTopicBarChart metric="organicTraffic" />
            </ChartContextProvider>
            <ChartContextProvider
              group={CHART_CONTEXT_GROUPS.BEACON_ORGANIC_TRAFFIC_BY_KEYWORD.name}
              chartName={CHART_NAMES.BEACON_ORGANIC_TRAFFIC_BY_KEYWORD_BAR}
            >
              <TrafficAdvancedSearchBarChart metric="organicClicks" groupByField="searchTerm" />
            </ChartContextProvider>
            <ChartContextProvider
              group={CHART_CONTEXT_GROUPS.BEACON_KEYWORDS_WITH_ORGANIC.name}
              chartName={CHART_NAMES.BEACON_KEYWORDS_WITH_ORGANIC_SPLINE}
            >
              <KeywordsWithOrganicTrafficSplineChart />
            </ChartContextProvider>
            {!['category', 'subcategory', 'product'].includes(mainEntityType) && (
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_ORGANIC_TRAFFIC_BY_CATEGORY.name}
                chartName={CHART_NAMES.BEACON_ORGANIC_TRAFFIC_BY_CATEGORY_BAR}
              >
                <TrafficAdvancedSearchBarChart metric="organicClicks" groupByField="categoryId" />
              </ChartContextProvider>
            )}
            {!['subcategory', 'product'].includes(mainEntityType) && (
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_ORGANIC_TRAFFIC_BY_SUBCATEGORY.name}
                chartName={CHART_NAMES.BEACON_ORGANIC_TRAFFIC_BY_SUBCATEGORY_BAR}
              >
                <TrafficAdvancedSearchBarChart metric="organicClicks" groupByField="subCategoryId" />
              </ChartContextProvider>
            )}
            <ChartContextProvider
              group={CHART_CONTEXT_GROUPS.BEACON_ORGANIC_PERCENT_TRAFFIC.name}
              chartName={CHART_NAMES.BEACON_ORGANIC_PERCENT_TRAFFIC_SPLINE}
            >
              <PercentTotalTrafficSplineChart trafficType="organicTraffic" />
            </ChartContextProvider>
            <OrganicTrafficGrid />
          </Flex>
        ) : (
          <TrafficNoDataPlaceholder />
        )}
      </BasePageContainer>
    </ExportConfigProvider>
  );
}
